import { Dialog } from 'primereact/dialog';
import { Button } from '@bbri/ui';
import React from 'react';

interface Props {
  isVisible: boolean;
  onClose: () => void;
  formService: any;
  t: any;
  isOnMobile: boolean;
  submission: any;
  values: any;
  history: any[];
  onConfirm: () => void;
}

export const SubmissionEditDialog: React.FC<Props> = ({
  isVisible,
  onClose,
  formService,
  t,
  isOnMobile,
  onConfirm
}) => (
  <Dialog
    header={formService.t(t, "ui_submission_edit_dialog_header", true)}
    visible={isVisible}
    modal
    focusOnShow={false}
    onShow={() => (document.activeElement as HTMLElement).blur()}
    style={isOnMobile ? { width: "95%" } : { width: "450px" }}
    onHide={onClose}
  >
    <div style={{ display: "flex" }}>
      <Button onClick={onConfirm}>
        {formService.t(t, "oui", false)}
      </Button>
      <Button onClick={onClose}>
        {formService.t(t, "non", false)}
      </Button>
    </div>
  </Dialog>
);